import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from '../../firebase';
import style from './HomePage.module.css';
import { useAuth } from "../login/AuthContext";

import logoAr from '../../assets/images/logoAr.png';
import logoEn from '../../assets/images/logoEn.png';

function HomePage() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    return (
        <div className={style.page}>
            <div className={style.imgbg}/>
            <div className={style.bg}/>
            <div className={style.container}>
                
                <div className={style.logos}>
                    <img className={style.logoEn} src={logoEn} alt="Logo English"/>
                    <img className={style.logoAr} src={logoAr} alt="Logo Arabic"/>
                </div>

                <p className={style.title}>The Hidden Gift</p>

                <button onClick={() => navigate('/games')}>Games</button>
                <button onClick={() => navigate('/gifts')}>Gifts</button>
                <button onClick={handleLogout}>Logout</button>
            </div>
        </div>
    );
}

export default HomePage;
